import script from "./SideNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNavBar.vue?vue&type=script&setup=true&lang=js"

import "./SideNavBar.vue?vue&type=style&index=0&id=38a81b1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a81b1e"]])

export default __exports__